import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

export const EditPhpVersionModal: FC<{ active: string | null, availableVersions: { [slug: string]: string }, save: (phpVersion: string) => Promise<void> }> = (props) => {
  const [selected, setSelected] = useState<string | null>(props.active)
  const save = () => {
    if (!selected) return Promise.resolve()
    return props.save(selected)
  }

  return <>
    <form onSubmit={() => save()} className={""}>
      <div className={"flex-1 grid grid-cols-3 gap-4 pb-3"}>
        {Object.entries(props.availableVersions).map(([slug, version]) => {
          return <button disabled={selected === slug} className={`border border-gray-200 rounded-lg ${selected !== slug ? 'bg-[#7A86B8]' : 'bg-[#4F5B93]'} flex flex-col items-center py-4`} type={"button"} onClick={() => setSelected(slug)}>
            {selected === slug ? <div className={"h-10 flex items-center justify-center"}>
              <FontAwesomeIcon icon={faCheckCircle} className={"text-white text-2xl"} />
            </div> : <img src="/php.svg" alt="" className={"h-10"} />}
            <span className={`mt-2 text-lg font-medium ${selected === slug ? 'text-white' : 'text-black'}`}>{version}</span>
          </button>
        })}
      </div>
      <ModalFooter text={"Save"} onSubmit={save} />
    </form>
  </>
}
